export default __webpack_public_path__ + "static/media/cheatday_frenchfries@3x.f96599f8.jpg";